import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  HTTP_GETTYPE,
  STATUS_API,
  TIMEOUT_DEFAULT,
  messageToastType_const,
  MSG_TIMEOUT_REQUEST
} from 'src/app/constant/config';
import AxiosAdapter from './AxiosAdapter';
import axiosInterceptor from '../app/axiosInterceptor';
import { MESSAGE } from 'src/app/constant/message';
import { showGlobalToast } from './uiSlice';

export const getListUsers = AxiosAdapter.GetHttp(
  'userSlice/getListUsers',
  '/users',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const getListSales = AxiosAdapter.GetHttp(
  'userSlice/getListSales',
  '/agencies/user/get',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const updateAvatar = AxiosAdapter.HttpPostUploadFile(
  'userSlice/updateAvatar',
  '/users/update-avatar',
);

export const createUser = AxiosAdapter.HttpPost(
  'userSlice/createUser',
  '/users/',
  MESSAGE.CREATE_USER_SUCCESS,
  'Tạo mới người dùng thất bại'
);

export const updateUser = AxiosAdapter.HttpUpdateById(
  'userSlice/updateUser',
  '/users/info',
  MESSAGE.UPDATE_USER_SUCCESS,
  'Cập nhật người dùng thất bại'
);

export const deleteUser = AxiosAdapter.HttpDelete(
  'userSlice/deleteUser',
  'users',
  MESSAGE.DELETE_USER_SUCCESS,
  'Xóa người dùng thất bại'
);

export const deleteMultiUsers = AxiosAdapter.HttpDeleteMulti(
  'userSlice/deleteMultiUser',
  'users',
  MESSAGE.DELETE_USER_SUCCESS,
  'Xóa người dùng thất bại'
);

export const getBusinessInfo = AxiosAdapter.GetHttp(
  'userSlice/getBusinessInfo',
  '/users/business/info',
  HTTP_GETTYPE.ALL_PAGINATION
);

const CUSTOMER_ACCOUNT_ERRORS = {
  'You do not have enough permission to perform this action':
    'Bạn không có quyền sửa thông tin khách hàng này',
  'Username already exists': 'Tên đăng nhập đã tồn tại',
  'User is not registered': 'Không tìm thấy khách hàng'
};

export const updateCustomerAccount = createAsyncThunk(
  'userSlice/updateCustomerAccount',
  async ({ userId, phone, username, full_name }, { rejectWithValue }) => {
    try {
      await axiosInterceptor.put(
        `/users/info/${userId}`,
        { phone, username, full_name },
        { skipForbiddenRedirect: true, timeout: TIMEOUT_DEFAULT }
      );
      return { userId, phone, username, full_name };
    } catch (err) {
      if (typeof err === 'string') return rejectWithValue({ message: err });
      const rawMessage = err?.data?.message;
      return rejectWithValue({
        status: err?.status,
        message:
          CUSTOMER_ACCOUNT_ERRORS[rawMessage] ||
          rawMessage ||
          'Cập nhật thông tin khách hàng thất bại'
      });
    }
  }
);

export const resetPasswordCustomer = createAsyncThunk(
  'userSlice/resetPasswordCustomer',
  (payload, { dispatch, rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/users/reset_password/customer/${payload.id}`,
        method: 'post',
        headers: {
          'Access-Control-Allow-Origin': true,
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: 'Bearer ' + localStorage.getItem('access-token'),
          timeout: TIMEOUT_DEFAULT
        },
      })
        .then(res => {
          dispatch(
            showGlobalToast({
              message: MESSAGE.RESET_PASSWORD_USER_SUCCESS,
              type: messageToastType_const.success
            })
          );

          resolve(res.data);
        })
        .catch(err => {
          if (err.code === 'ECONNABORTED') reject(MSG_TIMEOUT_REQUEST);
          if (!err.response) reject(err);

          dispatch(
            showGlobalToast({
              message:
                err?.response?.data?.message || MESSAGE.RESET_PASSWORD_USER_FAIL,
              type: messageToastType_const.error
            })
          );
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

export const changePasswordCustomer = createAsyncThunk(
  'userSlice/changePasswordCustomer',
  (payload, { dispatch, rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axiosInterceptor({
        url: `${process.env.REACT_APP_BACKEND_URL}/users/change_password/${payload.id}`,
        method: 'post',
        headers: {
          'Access-Control-Allow-Origin': true,
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: 'Bearer ' + localStorage.getItem('access-token'),
          timeout: TIMEOUT_DEFAULT
        },
        data: payload.data
      })
        .then(res => {
          dispatch(
            showGlobalToast({
              message: 'Đổi mật khẩu thành công',
              type: messageToastType_const.success
            })
          );

          resolve(res.data);
        })
        .catch(err => {
          if (err.code === 'ECONNABORTED') reject(MSG_TIMEOUT_REQUEST);
          if (!err.response) reject(err);

          dispatch(
            showGlobalToast({
              message:
              err?.response?.data?.message || 'Đổi mật khẩu thất bại',
              type: messageToastType_const.error
            })
          );
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

export const userSlice = createSlice({
  name: 'userSlice',
  initialState: {
    listUsers: [],
    listSales: [],
    totalSales: 0,
    businessInfo: null,
    statusCreate: null,
    statusGet: null,
    statusUpdate: null,
    statusDelete: null,
    statusDeleteMultiUsers: null,
    statusReset: null,
    statusChangePassword: null,
    errors: null,
    totalUsers: 0,
    isLoading: false,
  },
  reducers: {
    resetChange: state => {
      state.statusGet = null;
      state.statusCreate = null;
      state.statusDelete = null;
      state.statusDeleteMultiUsers = null;
      state.statusUpdate = null;
      state.errors = null;
      state.statusReset = null;
      state.statusChangePassword = null;
    },
    resetBusinessInfo: state => {
      state.businessInfo = null;
    },
    resetListUsers: state => {
      state.listUsers = [];
      state.totalUsers = 0;
      state.statusGet = null;
    }
  },
  extraReducers: {
    [getListUsers.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getListUsers.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.isLoading = false;
      state.listUsers = action.payload.payload.users;
      state.totalUsers = action.payload.payload.total;
    },
    [getListUsers.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.isLoading = false;
      state.errors = action.payload?.message || action.error;
    },
    // Get business info 
    [getBusinessInfo.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getBusinessInfo.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.isLoading = false;
      state.businessInfo = action.payload.payload.user;
    },
    [getBusinessInfo.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.isLoading = false;
      state.errors = action.payload?.message || action.error;
    },

    [getListSales.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getListSales.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.isLoading = false;
      state.listSales = action.payload?.payload?.users || [];
      state.totalSales = action.payload?.payload?.total || 0;
    },
    [getListSales.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.isLoading = false;
      state.errors = action.payload?.message || action.error;
    },

    [updateUser.pending]: state => {
      state.statusUpdate = STATUS_API.PENDING;
    },
    [updateUser.fulfilled]: (state, action) => {
      state.statusUpdate = STATUS_API.SUCCESS;
    },
    [updateUser.rejected]: (state, action) => {
      state.statusUpdate = STATUS_API.ERROR;
      state.errors = action.payload?.message || action.error;
    },

    [createUser.pending]: state => {
      state.statusCreate = STATUS_API.PENDING;
    },
    [createUser.fulfilled]: (state, action) => {
      state.statusCreate = STATUS_API.SUCCESS;
    },
    [createUser.rejected]: (state, action) => {
      state.statusCreate = STATUS_API.ERROR;
      state.errors = action.payload?.message || action.error;
    },

    [deleteUser.pending]: state => {
      state.statusDelete = STATUS_API.PENDING;
    },
    [deleteUser.fulfilled]: (state, action) => {
      state.statusDelete = STATUS_API.SUCCESS;
    },
    [deleteUser.rejected]: (state, action) => {
      state.statusDelete = STATUS_API.ERROR;
      state.errors = action.payload?.message || action.error;
    },

    [deleteMultiUsers.pending]: state => {
      state.statusDeleteMultiUsers = STATUS_API.PENDING;
    },
    [deleteMultiUsers.fulfilled]: (state, action) => {
      state.statusDeleteMultiUsers = STATUS_API.SUCCESS;
    },
    [deleteMultiUsers.rejected]: (state, action) => {
      state.statusDeleteMultiUsers = STATUS_API.ERROR;
      state.errors = action.payload?.message || action.error;
    },

    [resetPasswordCustomer.pending]: state => {
      state.statusReset = STATUS_API.PENDING;
    },
    [resetPasswordCustomer.fulfilled]: (state, action) => {
      state.statusReset = STATUS_API.SUCCESS;
    },
    [resetPasswordCustomer.rejected]: (state, action) => {
      state.statusReset = STATUS_API.ERROR;
      state.errors = action.payload?.message;
    },

    [changePasswordCustomer.pending]: state => {
      state.statusChangePassword = STATUS_API.PENDING;
    },
    [changePasswordCustomer.fulfilled]: state => {
      state.statusChangePassword = STATUS_API.SUCCESS;
    },
    [changePasswordCustomer.rejected]: (state, action) => {
      state.statusChangePassword = STATUS_API.ERROR;
      state.errors = action.payload?.message;
    },
  }
});
export const { resetChange, resetBusinessInfo, resetListUsers } = userSlice.actions;

export default userSlice.reducer;
